import React, { FunctionComponent } from 'react';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';

import App from './App';
import { RawAppData } from './types/app';

import {
  PersistGate as DefaultPersistGate,
  PersistGateProps,
} from 'redux-persist/integration/react';
import './index.scss';
import { getStore } from './store';
import { decodeAppData } from './utils/decodeAppData';

// Type version incomptability so that's a little trick
const PersistGate =
  DefaultPersistGate as unknown as FunctionComponent<PersistGateProps>;

/**
 * @description AppWrapper.default(rootElem, data) for init from PHP
 * @param rootElement
 * @param data
 * @constructor
 */
function AppWrapper(rootElement: HTMLElement, data: RawAppData) {
  const decodedData = decodeAppData(data);

  const persistSuffix = `:patrontech:multi:${decodedData.listingId}`;

  const { store, persistor } = getStore(persistSuffix); // pass decoded data here to have preinitialized store

  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App data={decodeAppData(data)} />
        </PersistGate>
      </Provider>
    </React.StrictMode>,
  );
}

export default AppWrapper;
